import {
  DemoIndicatorColoredIcon,
  PlaybookIcon,
  RecordingIndicatorColoredIcon,
  TourIndicatorColoredIcon,
} from '@carboncopyco/icons';
import type { Entity } from '@carboncopyco/types';
import { TextBase, TextLargeParagraph, TooltipBubble } from '@carboncopyco/ui';
import type React from 'react';
import type { ReactElement } from 'react';

const entityIcons: Record<
  'tour' | 'demo' | 'overlay' | 'record' | 'playbook',
  ReactElement
> = {
  tour: <TourIndicatorColoredIcon size={30} />,
  demo: <DemoIndicatorColoredIcon size={30} />,
  overlay: <DemoIndicatorColoredIcon size={30} />,
  record: <RecordingIndicatorColoredIcon size={30} />,
  playbook: <PlaybookIcon size={30} />,
};

const entityTitle: Record<
  'tour' | 'demo' | 'overlay' | 'record' | 'playbook',
  string
> = {
  tour: 'Tour',
  demo: 'Demo (cloned app)',
  overlay: 'Demo (live app)',
  record: 'Clone',
  playbook: 'Playbook',
};

type TabLayoutProps = {
  entity: Entity;
  actionButtons?: React.ReactNode;
  secondaryActionButtons?: React.ReactNode;
  title?: React.ReactElement;
  tabName?: string;
  tabSubtitle?: string;
  children: React.ReactNode;
  breadcrumbs?: React.ReactElement;
  readOnly?: boolean;
};

export const TabLayout = ({
  entity,
  actionButtons,
  secondaryActionButtons,
  tabName,
  tabSubtitle,
  children,
  title,
  breadcrumbs,
}: TabLayoutProps) => {
  return (
    <div className="w-full h-full bg-ds-natural-50 flex justify-center pt-10 overflow-hidden">
      <div className="w-full flex flex-col">
        <div className="w-[1008px] mb-ds-10 self-center">
          <div className="mb-4">{breadcrumbs}</div>
          <div className="flex items-center justify-between my-1">
            <div className="flex items-center gap-3 w-6/12">
              <TooltipBubble
                placement="top-start"
                title={entityTitle[entity]}
              >
                <div className="shrink-0">{entityIcons[entity]}</div>
              </TooltipBubble>
              <div className="w-ds-440">{title}</div>
            </div>
            {actionButtons}
          </div>
          {(tabSubtitle || secondaryActionButtons) && (
            <div className="flex mt-4">
              <div>
                <TextLargeParagraph
                  color="text-ds-natural-700"
                  label={tabName}
                />
                <TextBase
                  color="text-ds-natural-400"
                  label={tabSubtitle}
                />
              </div>
              {secondaryActionButtons}
            </div>
          )}
        </div>
        <div className="w-full overflow-y-auto flex justify-center grow">
          <div className="w-[1008px]">{children}</div>
        </div>
      </div>
    </div>
  );
};
